(function(){
    'use strict';
    angular
        .module('MW.ContactManager.ContactLandingController', [
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Influencers.CardButton',
            'MW.Influencers.ActionBarService',
            'ngMaterial'
        ])
        .controller('ContactLandingController', [
            '$scope',
            '$translate',
            'ContactManagerNavigationService',
            'ActionBarService',
            ContactLandingController
        ]);

    function ContactLandingController($scope, $translate, ContactManagerNavigationService, ActionBarService) {
        this.$translate = $translate;
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.ActionBarService = ActionBarService;
        this.title = this.$translate.instant('icm-contact-add-landing__title');
        this.importContactCardTitle = this.$translate.instant('icm-contact-add-landing__import-contact--title');
        this.importContactCardBody = this.$translate.instant('icm-contact-add-landing__import-contact--body');
        this.createContactCardTitle = this.$translate.instant('icm-contact-add-landing__create-contact--title');
        this.createContactCardBody = this.$translate.instant('icm-contact-add-landing__create-contact--body');

        this.ActionBarService.registerTitle(this.$translate.instant('icm-contact-add-landing__breadcrumb-title'));
        this.ActionBarService.setBackButtonVisibility(true);

        this.setCardTooltips = function setCardTooltips() {
            angular.element('mw-card-button#importContact > md-card').attr('title', this.importContactCardTitle);
            angular.element('mw-card-button#createContact > md-card').attr('title', this.createContactCardTitle);
        };
        this.setCardTooltips();
    }
}());
